import * as constants from 'helper/constants';
import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import strings from 'helper/localization/localization';
import YearOfBirthSelect from 'modules/personalDetails/YearOfBirthSelect';

import MockAPI from 'helper/mockApi'; // for prop-types
import API from '../../api/api'; // for prop-types

export default class EditPersonalDetails extends PureComponent {
  constructor(props) {
    super(props);

    // State
    this.state = {
      editSaved: false,
      errorMessage: null,
    };

    // Properties
    this.user = this.props.user;
    this.api = this.props.api;
    this.userAttrsToUpdate = {};
    this.updateUser = this.props.updateUser;

    // Bindings
    this.nicknameChanged = this.nicknameChanged.bind(this);
    this.yearOfBirthChanged = this.yearOfBirthChanged.bind(this);
    this.sexChanged = this.sexChanged.bind(this);
    this.submitChanges = this.submitChanges.bind(this);
  }

  nicknameChanged(event) {
    this.userAttrsToUpdate.nickname = event.target.value;
  }

  yearOfBirthChanged(year) {
    this.userAttrsToUpdate.yearOfBirth = year;
  }

  sexChanged(event) {
    this.userAttrsToUpdate.sex = event.target.value;
  }

  submitChanges(e) {
    e.preventDefault();
    this.setState({ errorMessage: null });

    // Only send update if user changed attribute(s)
    if (Object.keys(this.userAttrsToUpdate).length > 0) {
      this.api.updateUser(
        this.userAttrsToUpdate,
        (api) => {
          if (api.status === constants.api.success) {
            this.updateUser({ ...api.res.body });
          } else {
            this.setState({ errorMessage: strings.editPersonalDetailsFailure });
          }
        },
      );
    }
    this.setState({ editSaved: true });
  }

  render() {
    const redirect = (<Redirect
      push
      to={{
      pathname: '/',
      state: { successMessage: strings.editPersonalDetailsSuccess },
    }}
    />);
    const postSaveRedirect = this.state.editSaved ? redirect : null;


    const errorAlert = this.state.errorMessage ?
      (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {this.state.errorMessage}
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">{'\u00D7'}</span>
          </button>
        </div>
      ) : null;

    const sexOptions = ['female', 'male', 'intersex', 'unknown'].map(sex => (
      <option value={sex} key={sex}>
        {strings[sex]}
      </option>
    ));

    return (
      <div className="container">
        { postSaveRedirect }
        { errorAlert }
        <div className="row">
          <div className="col">
            <h2>{strings.navMyMimiAccount}</h2>
            <div className="font-weight-bold text-right mt-5">
              {strings.editPersonalDetails}
            </div>
          </div>
        </div>

        <form>
          <div className="form-group">
            <label htmlFor="account--name">{strings.yourName}</label>
            <input
              type="text"
              className="form-control"
              id="account--name"
              defaultValue={this.user.nickname}
              onChange={this.nicknameChanged}
            />
          </div>
          <YearOfBirthSelect
            yearOfBirth={this.user.yearOfBirth}
            updateYear={this.yearOfBirthChanged}
          />
          <div className="form-group">
            <label htmlFor="account--sex">{strings.biologicalSex}</label>
            <select
              className="form-control custom-select"
              id="account--sex"
              onChange={this.sexChanged}
              defaultValue={this.user.sex}
            >
              {sexOptions}
            </select>
          </div>
          <button
            type="submit"
            className="btn btn-outline-primary btn-lg btn-block"
            onClick={this.submitChanges}
            id="account--save"
          >
            {strings.saveChanges}
          </button>
        </form>
      </div>
    );
  }
}

EditPersonalDetails.propTypes = {
  api: PropTypes.oneOfType([
    PropTypes.instanceOf(API),
    PropTypes.instanceOf(MockAPI),
  ]).isRequired,
  updateUser: PropTypes.func.isRequired,
  user: PropTypes.shape({
    nickname: PropTypes.string,
    sex: PropTypes.string,
    yearOfBirth: PropTypes.number.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/personalDetails/EditPersonalDetails.jsx